module.exports = __webpack_public_path__ + "static/capstone-5d228e7351d259ad96e90b832ce8b924.jpeg";